// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Toasted from 'vue-toasted'
import {BootstrapVue, CollapsePlugin, DropdownPlugin, TooltipPlugin, NavbarPlugin} from 'bootstrap-vue'

Vue.use(require('vue-script2'));
import Ads from 'vue-google-adsense'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/main.css'

Vue.use(BootstrapVue);
Vue.use(CollapsePlugin);
Vue.use(TooltipPlugin);
Vue.use(NavbarPlugin);
Vue.use(DropdownPlugin);
Vue.use(Toasted);


// Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);

// Vue.use(Ads.AutoAdsense, { adClient: 'ca-pub-6075100011305267' })

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    niceDate: function (date) {
      return Moment.utc(date).format('YYYY-MM-DD H:m:ss')
    },
    niceDateHuman: function (date) {
      return Moment.utc(date).fromNow()
    },
    ucFirst: function (string) {
      if (string === null || string === undefined) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    ucHuman: function (string) {
      if (string === null || string === undefined) return '';

      return this.ucFirst(string.replace('_', ' '))
    }
  }
});

console.log("ENV: ", process.env.API_ADDR);


//Set base title
document.title = 'OSRS Genie - DPS Calculator';


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js